import script from "./EsimList.vue?vue&type=script&setup=true&lang=ts"
export * from "./EsimList.vue?vue&type=script&setup=true&lang=ts"

import "./EsimList.vue?vue&type=style&index=0&id=1edb2e64&scoped=true&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1edb2e64"]])

export default __exports__